import React, { useState, useEffect } from "react";
import withAppData from "../../HOC/withAppData";
import SinglePage from "../../Layout/SinglePage";
import "../../Styles/Pages/transactionhistory.scss";
import { POST } from "../../Utils/api";
import EmptyState from "../../Accounts/EmptyState";
import Loading from "../../Loaders/Loading";
import ViewMore from "../../Resources/ViewMore";
import { _formatCurrency, _formatDate } from "../../Utils/helpers";

const tableHead = ["All", "In", "Out"];

const TransactionHistory = props => {
	const [transactionType, setTransactionType] = useState("");
	// const [searchValue, setSearchValue] = useState("");
	const [activeTabIndex, setActiveTabIndex] = useState(0);
	const [loadingTransactions, setLoadingTransactions] = useState(true);
	const [isLoadingMore, setIsLoadingMore] = useState(false);
	const [pageNo, setPageNo] = useState(1);
	// const [startDate, setStartDate] = useState("2021-01-01");
	// const [endDate, setEndDate] = useState("2023-01-01");
	const [totalTransactions, setTotalTransactions] = useState(0);
	const [transactions, setTransactions] = useState([]);
	const recordsPerPage = 20;

	useEffect(() => {
		getTransactionHistory(pageNo, "");
	}, [activeTabIndex]);

	const changeTab = index => {
		setLoadingTransactions(true);
		setTransactionType(index === 0 ? "" : index === 1 ? "Credit" : "Debit");
		setActiveTabIndex(index);
	};

	const getTransactionHistory = async (pageNo, searchValue) => {
		setPageNo(pageNo);
		const postData = {
			RequesterId: props.context.userId,
			Search: searchValue,
			StartDate: "",
			EndDate: "",
			PageNo: pageNo,
			RecordsPerPage: recordsPerPage,
			TransactionType: transactionType,
		};
		const transactionHistory = await POST(
			`OmniPay/GetOmnipayShipmentTransactions`,
			postData,
		);

		if (!transactionHistory.error) {
			const data = transactionHistory.Data.TransactionsList;
			const totalNo = transactionHistory.Data.TotalTransactions;
			if (pageNo > 1) {
				let itemListData = transactions.concat(data);
				setTransactions(itemListData);
			} else {
				setTransactions(data);
			}
			setTotalTransactions(totalNo);
		}
		setLoadingTransactions(false);
		setIsLoadingMore(false);
	};

	return (
		<SinglePage heading={"Transaction History"} backAction={props.backAction}>
			<div className="transaction-history">
				<div className="transaction-history-tabs">
					{tableHead.map((val, index) => (
						<div
							key={index}
							onClick={() => changeTab(index)}
							className={`tab ${activeTabIndex === index ? "active" : ""}`}
						>
							{val}
						</div>
					))}
				</div>

				{loadingTransactions ? (
					<Loading size={"4px"} />
				) : transactions && transactions.length > 0 ? (
					<div className="transaction-history-items">
						{transactions.map((transaction, index) => (
							<div key={index} className="transaction-history-body">
								<div className="transaction-history-item">
									<div className="transaction-history-item-logo">
										<img
											src={`Images/${
												transaction.TransactionType === "Debit"
													? "debit-history.svg"
													: "credit-history.svg"
											} `}
											style={{ width: "100%" }}
											alt="transaction"
										/>
									</div>
									<div className="transaction-history-item-details">
										<div className="transaction-history-item-details-top">
											<p>{transaction.Description}</p>
											<p
												className={`transaction-history-item-details-top-price-${
													transaction.TransactionType === "Debit"
														? "debit"
														: "credit"
												}`}
											>
												{_formatCurrency(transaction.Amount || 0)}
											</p>
										</div>
										<div className="transaction-history-item-details-bottom">
											<p className="transaction-history-item-details-bottom-transfer">
												Transfer
											</p>
											<p>
												{_formatDate(
													transaction.CreatedDate,
													"YYYY-MM-DD hh:mm A",
												)}
											</p>
										</div>
									</div>
								</div>
								<hr style={{ borderTop: "1px solid rgb(217 220 225)" }} />
							</div>
						))}
						{totalTransactions > transactions.length && (
							<ViewMore
								load={() => {
									setIsLoadingMore(true);
									getTransactionHistory(pageNo + 1, "");
								}}
								loading={isLoadingMore}
							/>
						)}
					</div>
				) : (
					<EmptyState
						text={"No found data"}
						//   height={"80px"}
						lightText={true}
					/>
				)}
			</div>
		</SinglePage>
	);
};

export default withAppData(TransactionHistory);
